import { entryTiles, hotChips, tickerItems } from "@/mocks/gua";

export default function Hero() {
  const items = [...tickerItems, ...tickerItems];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-background-100 via-background-50 to-background-100">
      {/* 压顶更新条 */}
      <div className="relative flex h-9 items-center overflow-hidden bg-primary-500 text-background-50">
        <div className="relative z-10 flex h-full shrink-0 items-center gap-1 bg-primary-600 px-3 sm:px-4">
          <i className="ri-radio-2-line animate-pulse text-sm" aria-hidden="true"></i>
          <span className="whitespace-nowrap text-xs font-semibold tracking-widest">直播速递</span>
        </div>
        <div className="flex flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-8 pl-6">
            {items.map((t, i) => (
              <span key={i} className="flex items-center gap-2 whitespace-nowrap text-xs sm:text-sm">
                <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="wrap grid items-center gap-10 py-10 md:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
        {/* 左：主文案 */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-seedling-line" aria-hidden="true"></i>
            事件梳理 · 时间线 · 完整复盘 一站式入口
          </span>
          <h1 className="mt-5 font-heading text-4xl font-bold leading-[1.15] text-foreground-950 md:text-5xl">
            吃瓜不迷路，
            <br />
            一次<span className="text-primary-500">理清前因后果</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            从最新瓜点到重点事件，我们按时间线把前因后果背景解析一次讲透。
            <span className="text-foreground-800 font-medium">过去说了什么、现在吵到哪、背后到底怎么回事</span>
            ——给你一份看得懂的完整复盘。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#board"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              进入今日热度榜
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#replay"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-clipboard-line" aria-hidden="true"></i>
              围观最新复盘
            </a>
          </div>

          <div className="mt-7 flex flex-wrap gap-2">
            {hotChips.map((c, i) => (
              <a
                key={c}
                href={i === 0 ? "#feed" : "#topics"}
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
              >
                <i className="ri-fire-line text-secondary-500" aria-hidden="true"></i>
                {c}
              </a>
            ))}
          </div>
        </div>

        {/* 右：入口条 资源落地感 */}
        <div className="rounded-2xl border border-background-200 bg-background-50 p-4 sm:p-5">
          <div className="flex items-center justify-between">
            <h2 className="font-heading text-lg font-bold text-foreground-950">快速入口</h2>
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-refresh-line" aria-hidden="true"></i>
              今日已更新 24 条
            </span>
          </div>
          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {entryTiles.map((e) => (
              <a
                key={e.title}
                href={e.href}
                className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-100/60 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                  <i className={e.icon} aria-hidden="true"></i>
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-1 text-sm font-semibold text-foreground-950">
                    {e.title}
                    <i className="ri-arrow-right-line text-primary-500 opacity-0 transition-opacity group-hover:opacity-100" aria-hidden="true"></i>
                  </span>
                  <span className="mt-0.5 block truncate text-xs text-foreground-600">{e.desc}</span>
                </span>
              </a>
            ))}
          </div>
          <div className="mt-4 grid grid-cols-3 divide-x divide-background-200 rounded-xl border border-background-200 bg-background-100/60 py-3 text-center">
            <div>
              <div className="font-heading text-xl font-bold text-primary-600">24</div>
              <div className="text-xs text-foreground-500">今日瓜点</div>
            </div>
            <div>
              <div className="font-heading text-xl font-bold text-accent-600">128</div>
              <div className="text-xs text-foreground-500">累计复盘</div>
            </div>
            <div>
              <div className="font-heading text-xl font-bold text-secondary-600">98</div>
              <div className="text-xs text-foreground-500">热度峰值</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}